import { SimpleGuard } from 'interfaces/guards'
import { TimeframeTyped } from 'interfaces/global'
import { getMemberNetworthChangeActionCreator, getNetworthSummaryActionCreator } from 'actions/networthActions'
import { memberNetworthChangeSelector } from 'selectors/genericSelectors'
import {
  networthSummaryAmountSelector,
  networthSummaryAppSelector,
  networthSummaryDeltaSelector,
  networthSummaryRankSelector,
} from 'selectors/networthSelectors'

export const memberNetworthChangeGuard: SimpleGuard<TimeframeTyped> = {
  name: 'Member Networth Change Guard',
  checker: (state, ownProps) =>
    Boolean(memberNetworthChangeSelector(state, ownProps)),
  loader: (dispatch, { timeframe }) =>
    dispatch(getMemberNetworthChangeActionCreator(timeframe)),
}

export const networthSummaryFirstRequestGuard: SimpleGuard = {
  name: 'Networth Summary Initial Guard',
  checker: (state) => {
    const { relationId, timeframe } = networthSummaryAppSelector(state)
    return Boolean(relationId && timeframe)
  },
  loader: (dispatch) => {
    dispatch(getNetworthSummaryActionCreator.request({}))
  },
}

export const networthSummaryDeltaGuard: SimpleGuard = {
  name: 'Networth Summary Guard',
  checker: (state) => Boolean(networthSummaryDeltaSelector(state)),
  loader: () => { /* do nothing */ },
}

export const networthSummaryRankGuard: SimpleGuard = {
  name: 'Networth Summary Guard',
  checker: (state) => Boolean(networthSummaryRankSelector(state)),
  loader: () => { /* do nothing */ },
}

export const networthSummaryAmountGuard: SimpleGuard = {
  name: 'Networth Amount Guard',
  checker: (state) => networthSummaryAmountSelector(state) !== null,
  loader: (dispatch) => {
    dispatch(getNetworthSummaryActionCreator.request({}))
  },
}
